<template>
  <div class="py-4">
    <vendor-comp-item-list
      class=""
      :vendorId="resource.id"
      :enabled-columns="['title', 'comp_item', 'valid_to', 'overall_status', 'files']"
    ></vendor-comp-item-list>
  </div>
</template>

<script>
  export default {
    components: {},
    props: ['resource'],
  };
</script>
